import "./app"

import PlatformSelector from "./lib/public/platform_selector"
import ProductVersionSelector from "./lib/public/product_version_selector"

PlatformSelector.start()
ProductVersionSelector.start()
